import React from 'react'

const LibraryTableHead = ({ sortReports, sortSetting }) => {
  return (
    <thead>
      <tr>
        <th onClick={() => sortReports('createdDate')}>
          <span>Date</span>
          <input type="button" className={sortSetting.column === 'createdDate' ? sortSetting.order === 'asc' ? 'sortIcon' : 'sortIcon down' : 'hide'} />
        </th>
        <th onClick={() => sortReports('name')}>
          <span>Name</span>
          <input type="button" className={sortSetting.column === 'name' ? sortSetting.order === 'asc' ? 'sortIcon' : 'sortIcon down' : 'hide'} />
        </th>
        <th onClick={() => sortReports('datasetName')}>
          <span>Source</span>
          <input type="button" className={sortSetting.column === 'datasetName' ? sortSetting.order === 'asc' ? 'sortIcon' : 'sortIcon down' : 'hide'} />
        </th>
        <th>Downloads</th>
        <th>Actions</th>
      </tr>
    </thead>
  )
}

export default LibraryTableHead
